/**
 * Tiny analytics helper for firing Meta Pixel + GA4 events.
 * Safe to call before the trackers are loaded — calls are no-ops if not ready.
 *
 * Standard Meta event names: https://developers.facebook.com/docs/meta-pixel/reference#standard-events
 *  - Lead, Contact, Schedule, CompleteRegistration, ViewContent, InitiateCheckout, Purchase
 */

export const trackEvent = (eventName, params = {}) => {
  try {
    if (typeof window === "undefined") return;
    // Meta Pixel
    if (typeof window.fbq === "function") {
      window.fbq("track", eventName, params);
    }
    // GA4 (Google Tag)
    if (typeof window.gtag === "function") {
      window.gtag("event", eventName, params);
    }
    // Debug
    if (process.env.NODE_ENV !== "production") {
      // eslint-disable-next-line no-console
      console.info(`[analytics] ${eventName}`, params);
    }
  } catch (_) {
    // ignore tracking errors so they never break UX
  }
};

export const trackLead = (params = {}) => trackEvent("Lead", params);
export const trackContact = (params = {}) => trackEvent("Contact", params);
export const trackSchedule = (params = {}) => trackEvent("Schedule", params);
export const trackInitiateCheckout = (params = {}) => trackEvent("InitiateCheckout", params);
export const trackCompleteRegistration = (params = {}) => trackEvent("CompleteRegistration", params);
